$(document).ready(function() {
    zermatusaInitFunctions();
});

function zermatusaInitFunctions() {
    zermatusaPrintLogBeauty('Cargando funciones ZermatUSA...');
    zermatusaPrintLog('Idioma actual en la tienda', zermatusaGetCurrentLanguage());
    if (window.location.search === '?clearCache') {
        zermatusaClearAffiliateCacheAndCookies();
    }
}

function zermatusaIsMobileDevice() {
  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
}

function zermatusaGetCurrentLanguage() {
  let language = 'en';
  if (window.location.pathname.startsWith('/es'))
    language = 'es';
  return language;
}

function zermatusaPrintLogBeauty(message) {
  console.log('%c \u25BA zermatusa-functions.js --> ' + message, "background-color: #FF0B53; color: #fff; padding: 5px;");
}

function zermatusaPrintLog(message, data) {
  if (data !== undefined)
    console.log('zermatusa-functions.js --> ' + message + ':', data);
  else
    console.log('zermatusa-functions.js --> ' + message);
}

function zermatusaClearAffiliateCacheAndCookies(mode) {
    zermatusaDeleteCacheEntry('ref');
    zermatusaDeleteCookie('ref', window.location.host);
    zermatusaDeleteCookie('ref');
    window.location = window.location.pathname;
}

function zermatusaDeleteCacheEntry(name) {
  localStorage.removeItem(name);
}

function zermatusaDeleteCookie(name, domain = '', path = '/') {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;' + 'path=' + path + ';' + (domain ? 'domain=' + domain + ';' : '');
}

function zermatusaPrintMyIp() {
  fetch("https://api.ipify.org?format=json")
  .then(response => response.json())
  .then(data => {
    zermatusaPrintLog('IP pública', data.ip);
  });
}